import React from 'react';
import { FaEdge, FaChrome, FaSafari, FaFirefox, FaGlobe } from 'react-icons/fa';

interface IBrowserIcon {
  browserName: string | undefined;
}

export const BrowserIcon = ({ browserName }: IBrowserIcon) => {
  switch (browserName) {
    case 'Microsoft Edge':
      return <FaEdge />;
    case 'Chrome':
      return <FaChrome />;
    case 'Safari':
      return <FaSafari />;
    case 'Firefox':
      return <FaFirefox />;
    default:
      return <FaGlobe />;
  }
};
